/** @jsxRuntime automatic */
/** @jsxImportSource react */
import { useEffect, useRef, useState } from 'react'
import { frame } from './flight/state.ts'

// Dev controls, only mounted when the URL contains ?dev (leva must not ship, so this is
// a hand-rolled 40-line stand-in — ISSUES.md #10). The flowMode slider is build-order
// step 4: turbulent -> constrained -> grid must feel good dragged by hand.
export function DevPanel() {
  const [devP, setDevP] = useState(-1)
  const [devFlow, setDevFlow] = useState(-1)
  const pRef = useRef<HTMLSpanElement>(null)

  useEffect(() => {
    frame.devP = devP
    frame.devFlow = devFlow
  }, [devP, devFlow])

  useEffect(() => {
    let raf = 0
    const tick = () => {
      if (pRef.current) pRef.current.textContent = frame.p.toFixed(3)
      raf = requestAnimationFrame(tick)
    }
    raf = requestAnimationFrame(tick)
    return () => cancelAnimationFrame(raf)
  }, [])

  return (
    <div className="dev-panel">
      <div>
        p <span ref={pRef}>0</span>
      </div>
      <label>
        progress override
        <input type="range" min={-0.01} max={1} step={0.001} value={devP}
          onChange={(e) => setDevP(parseFloat(e.target.value))} />
        <button type="button" onClick={() => setDevP(-1)}>×</button>
      </label>
      <label>
        flowMode override
        <input type="range" min={-0.05} max={3} step={0.01} value={devFlow}
          onChange={(e) => setDevFlow(parseFloat(e.target.value))} />
        <button type="button" onClick={() => setDevFlow(-1)}>×</button>
      </label>
    </div>
  )
}
